export default __webpack_public_path__ + "static/media/living-room.803a55e5.mp4";